import { defineComponent as A, inject as N, ref as v, computed as L, h as C, Transition as D, withDirectives as _, vShow as j, nextTick as R } from "vue";
import { loadingBarProviderInjectionKey as V } from "./ghl-ui.es1041.js";
import P from "./ghl-ui.es1366.js";
import k from "./ghl-ui.es854.js";
import H from "./ghl-ui.es855.js";
import { useThemeClass as I } from "./ghl-ui.es857.js";
import K from "./ghl-ui.es1175.js";
var g = globalThis && globalThis.__awaiter || function(o, n, i, r) {
  function u(s) {
    return s instanceof i ? s : new i(function(t) {
      t(s);
    });
  }
  return new (i || (i = Promise))(function(s, t) {
    function m(l) {
      try {
        a(r.next(l));
      } catch (c) {
        t(c);
      }
    }
    function d(l) {
      try {
        a(r.throw(l));
      } catch (c) {
        t(c);
      }
    }
    function a(l) {
      l.done ? s(l.value) : u(l.value).then(m, d);
    }
    a((r = r.apply(o, n || [])).next());
  });
};
function p(o, n) {
  return `${n}-loading-bar ${n}-loading-bar--${o}`;
}
const Q = A({
  name: "LoadingBar",
  props: {
    containerClass: String,
    containerStyle: [String, Object]
  },
  setup() {
    const {
      inlineThemeDisabled: o
    } = k(), {
      props: n,
      mergedClsPrefixRef: i
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = N(V), r = v(null), u = v(!1), s = v(!1), t = v(!1), m = v(!1);
    let d = !1;
    const a = v(!1), l = L(() => {
      const {
        loadingBarStyle: e
      } = n;
      return e ? e[a.value ? "error" : "loading"] : "";
    });
    function c() {
      return g(this, void 0, void 0, function* () {
        u.value = !1, t.value = !1, d = !1, a.value = !1, m.value = !0, yield R(), m.value = !1;
      });
    }
    function x(e = 0, y = 80, b = "starting") {
      return g(this, void 0, void 0, function* () {
        if (s.value = !0, yield c(), d)
          return;
        t.value = !0, yield R();
        const f = r.value;
        f && (f.style.maxWidth = `${e}%`, f.style.transition = "none", f.offsetWidth, f.className = p(b, i.value), f.style.transition = "", f.style.maxWidth = `${y}%`);
      });
    }
    function S() {
      return g(this, void 0, void 0, function* () {
        if (d || a.value)
          return;
        s.value && (yield R()), d = !0;
        const e = r.value;
        e && (e.className = p("finishing", i.value), e.style.maxWidth = "100%", e.offsetWidth, t.value = !1);
      });
    }
    function W() {
      if (!(d || a.value))
        if (!t.value)
          x(100, 100, "error").then(() => {
            a.value = !0;
            const e = r.value;
            e && (e.className = p("error", i.value), e.offsetWidth, t.value = !1);
          });
        else {
          a.value = !0;
          const e = r.value;
          if (!e)
            return;
          e.className = p("error", i.value), e.style.maxWidth = "100%", e.offsetWidth, t.value = !1;
        }
    }
    function w() {
      u.value = !0;
    }
    function E() {
      u.value = !1;
    }
    function T() {
      return g(this, void 0, void 0, function* () {
        yield c();
      });
    }
    const $ = H("LoadingBar", "-loading-bar", P, K, n, i), B = L(() => {
      const {
        self: {
          height: e,
          colorError: y,
          colorLoading: b
        }
      } = $.value;
      return {
        "--n-height": e,
        "--n-color-loading": b,
        "--n-color-error": y
      };
    }), h = o ? I("loading-bar", void 0, B, n) : void 0;
    return {
      mergedClsPrefix: i,
      loadingBarRef: r,
      started: s,
      loading: t,
      entering: u,
      transitionDisabled: m,
      start: x,
      error: W,
      finish: S,
      handleEnter: w,
      handleAfterEnter: E,
      handleAfterLeave: T,
      mergedLoadingBarStyle: l,
      cssVars: o ? void 0 : B,
      themeClass: h == null ? void 0 : h.themeClass,
      onRender: h == null ? void 0 : h.onRender
    };
  },
  render() {
    if (!this.started)
      return null;
    const {
      mergedClsPrefix: o
    } = this;
    return C(D, {
      name: "fade-in-transition",
      appear: !0,
      onEnter: this.handleEnter,
      onAfterEnter: this.handleAfterEnter,
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onAfterLeave: this.handleAfterLeave,
      css: !this.transitionDisabled
    }, {
      default: () => {
        var n;
        return (n = this.onRender) === null || n === void 0 || n.call(this), _(C("div", {
          class: [`${o}-loading-bar-container`, this.themeClass, this.containerClass],
          style: this.containerStyle
        }, C("div", {
          ref: "loadingBarRef",
          class: [`${o}-loading-bar`],
          style: [this.cssVars, this.mergedLoadingBarStyle]
        })), [[j, this.loading || !this.loading && this.entering]]);
      }
    });
  }
});
export {
  Q as default
};
